import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  team: null,
  channels: {},
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.SLACK_TEAM_LOADED: {
      result = _.assign({}, state, {
        team: action.payload.team,
      });
      break;
    }

    case actionTypes.SLACK_CHANNELS_LOADED: {
      result = _.assign({}, state, {
        channels: _.keyBy(action.payload.channels, 'id'),
      });
      break;
    }

    case actionTypes.SLACK_CHANNELS_UPDATED: {
      result = _.assign({}, state, {
        channels: _.keyBy(action.payload.channels, 'id'),
      });
      break;
    }

    case actionTypes.SLACK_CHANNEL_ADDED_TO_BLACKLIST: {
      const channelId = action.payload.channelId;
      result = _.assign({}, state);
      result.channels[channelId].blacklisted = true;
      break;
    }

    case actionTypes.SLACK_CHANNEL_REMOVED_FROM_BLACKLIST: {
      const channelId = action.payload.channelId;
      result = _.assign({}, state);
      result.channels[channelId].blacklisted = false;
      break;
    }

    default: {
      result = _.assign({}, state);
    }

  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/slack.js